import React, { useState, useEffect } from "react";
import DashboardCard from "../DashBoardCard";

function GlobalDashboard() {
  const [stats, setStats] = useState({ dashboard: {} });

  useEffect(() => {
    fetch("https://corona-virus-stats.herokuapp.com/api/v1/cases/general-stats")
      .then((response) => response.json())
      .then((response) => {
        setStats({
          dashboard: response.data,
        });
      })
      .catch(() => console.log("Something went wrong..."));
  }, []);

  return (
    <React.Fragment>
      <div className="container mt-3">
        <div
          className="alert alert-success main-heading p-3"
          role="alert"
          data-aos="fade-up"
          data-aos-duration="1200"
        >
          <h2>Global Information</h2>
          <p>Last Updated: {stats.dashboard.last_update}</p>
        </div>
        <div className="container d-gap">
          <div className="row">
            <div
              className="col-md-4 col-sm-4 col-6 np-5 np"
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <div
                className="my-3 text-center shadow"
                style={{ backgroundColor: "#fff" }}
              >
                <i
                  class="fa fa-hospital-o text-primary fa-card-position-1"
                  aria-hidden="true"
                ></i>
                <DashboardCard
                  count={stats.dashboard.currently_infected}
                  cardTitle="New Cases"
                />
              </div>
            </div>
            <div
              className="col-md-4 col-sm-4 col-6 np-5 np"
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <div
                className="my-3 text-center shadow"
                style={{ backgroundColor: "#fff" }}
              >
                <i
                  class="fa fa-exclamation-triangle text-danger fa-card-position-1"
                  aria-hidden="true"
                ></i>
                <DashboardCard
                  count={stats.dashboard.death_cases}
                  cardTitle="Total Deaths"
                />
              </div>
            </div>
            <div
              className="col-md-4 col-sm-4 col-6 np-5 np"
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <div
                className="my-3 text-center shadow"
                style={{ backgroundColor: "#fff" }}
              >
                <i
                  class="fa fa-plus-square text-success fa-card-position-1"
                  aria-hidden="true"
                ></i>
                <DashboardCard
                  count={stats.dashboard.recovery_cases}
                  cardTitle="Total Recovered"
                />
              </div>
            </div>
            <div
              className="col-md-4 col-sm-4 col-6 np-5 np"
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <div
                className="my-3 text-center shadow"
                style={{ backgroundColor: "#fff" }}
              >
                <i
                  class="fa fa-user-md text-warning fa-card-position-1"
                  aria-hidden="true"
                ></i>
                <DashboardCard
                  count={stats.dashboard.active_cases_critical_percentage}
                  cardTitle="Active Critical Rate"
                />
              </div>
            </div>
            <div
              className="col-md-4 col-sm-4 col-6 np-5 np"
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <div
                className="my-3 text-center shadow"
                style={{ backgroundColor: "#fff" }}
              >
                <i
                  class="fa fa-ambulance fa-card-position text-info"
                  aria-hidden="true"
                ></i>
                <DashboardCard
                  count={stats.dashboard.closed_cases_death_percentage}
                  cardTitle="Death Rate"
                />
              </div>
            </div>
            <div
              className="col-md-4 col-sm-4 col-6 np-5 np"
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <div
                className="my-3 text-center shadow"
                style={{ backgroundColor: "#fff" }}
              >
                <i
                  class="fa fa-medkit text-warning fa-card-position-1"
                  aria-hidden="true"
                ></i>
                <DashboardCard
                  count={stats.dashboard.closed_cases_recovered_percentage}
                  cardTitle="Recovered Rate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
export default GlobalDashboard;
